// Alias
import DefaultSectionDivider from '../../section-divider';

export default DefaultSectionDivider;



// WEBPACK FOOTER //
// ./components/lookup/menu/default-section-divider/index.jsx